<template>
  <svg id="loader" class="loader" width="16px" height="16px">
    <g width="16px" height="16px">  
      <circle cx="8" cy="8" r="6" stroke="white" stroke-width="2" stroke-linecap="square" fill="none" />
    </g>
  </svg>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  svg.loader {
    animation: ROTOR 2s ease infinite;

    @keyframes ROTOR {
      0%, 50% {
        transform:rotate(0deg)
      }
      
      to {
        transform:rotate(360deg)
      }
    }

    g {
      transform-origin: center center;
      animation: LOADERROTORFULL 1.6s linear infinite;

      @keyframes LOADERROTORFULL{
        0% {
          transform:rotate(0deg)
        }
        
        to {
          transform:rotate(360deg)
        }
      }
    }

    circle {
      animation: DASHLOADER 2s ease infinite;

      @keyframes DASHLOADER{
        0%, to {
          stroke-dasharray: 1px, 45px;
          stroke-dashoffset: 0;
        }
        
        50% {
          stroke-dasharray: 35px, 45px;
          stroke-dashoffset: 0;
        }
      }
    }
  }
</style>

